exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-row-wrapper{display:flex;flex-flow:row nowrap;align-items:flex-start}.flex-href{overflow-y:auto;padding:2em;color:#428bca!important}.flex-href:hover{cursor:pointer;color:#d3d3d3!important}.fg-1{flex-grow:1}.secondary-btn{background-color:#333!important}", ""]);

// exports
